import { Box, Flex, Text, VStack, Heading, Image } from "@chakra-ui/react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { AppInput, AppButton } from "../../components";
import { colors } from "../../theme";
import { setLoginUser, setUserToken, logoutUser } from "../../redux/reducer/userSlice";
import { makeRequest } from "../../services/instance";
import { getAdminProfile, loginAdmin } from "../../services/apiCalls";
import { setLoading, showToast } from "../../redux/reducer/utilsSlice";

const LoginScreen = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
const isLoading = useSelector((state) => state.utils.loading);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data) => {
    dispatch(setLoading(true));
    try {
      // API call to login
      const response = await loginAdmin(data);

      // Store token
      if (response.token) {
        dispatch(setUserToken(response.token));
      }

      const profile = await getAdminProfile();

      // ADMIN = global super admin; MALL_ADMIN = scoped to their managedMallId
      // (GAP-018). Anyone else must not stay authenticated in the panel.
      if (["ADMIN", "MALL_ADMIN"].includes(profile?.user?.role)) {
        dispatch(setLoginUser(profile?.user));
        navigate("/dashboard");
      } else {
        dispatch(logoutUser());
        alert("Access denied. You are not an admin.");
      }
    } catch (error) {
      // 401 from the login endpoint means bad credentials — show a precise
      // message instead of the interceptor's generic/"session expired" toast.
      const msg =
        error?.status === 401
          ? "Invalid email or password."
          : error?.message || "Login failed. Please try again.";
      dispatch(showToast(msg));
    } finally {
      dispatch(setLoading(false));
    }
  };

  return (
    <Flex
      minH="100vh"
      bg={colors.background}
      align="center"
      justify="center"
      p={4}
    >
      <Box
        bg="white"
        p={8}
        borderRadius="xl"
        boxShadow="lg"
        w="100%"
        maxW="420px"
      >
        {/* Logo */}
        <Flex direction="column" align="center" mb={8}>
          <Image
            src={`${process.env.PUBLIC_URL}/brand/mallbuddy-logo-stacked.png`}
            alt="MallBuddy, in-mall delivery"
            w="190px"
            mb={5}
          />
          <Heading size="lg" color={colors.text} mb={2}>
            Admin console
          </Heading>
          <Text color={colors.textSecondary} fontSize="sm">
            Sign in to your admin account
          </Text>
        </Flex>

        {/* Login Form */}
        <form onSubmit={handleSubmit(onSubmit)}>
          <VStack spacing={4}>
            <AppInput
              label="Email Address"
              name="email"
              type="email"
              placeholder="Enter your email"
              register={register}
              errors={errors}
              required
            />

            <AppInput
              label="Password"
              name="password"
              type="password"
              placeholder="Enter your password"
              register={register}
              errors={errors}
              required
            />

            <AppButton
              type="submit"
              variant="primary"
              w="100%"
              size="lg"
              isLoading={isLoading}
              mt={4}
            >
              Sign In
            </AppButton>
          </VStack>
        </form>

        {/* Footer */}
        <Text
          mt={8}
          textAlign="center"
          fontSize="xs"
          color={colors.textSecondary}
        >
          © {new Date().getFullYear()} MallBuddy. All rights reserved.
        </Text>
      </Box>
    </Flex>
  );
};

export default LoginScreen;
